export enum EMBEDDED_JOURNEY_MESSAGE_EVENT_TYPE {
  EXIT_FULL_SCREEN = 'EPILOT/EXIT_FULLSCREEN',
  ENTER_FULL_SCREEN = 'EPILOT/ENTER_FULLSCREEN',
  FORM_EVENT = 'EPILOT/FORM_EVENT',
  JOURNEY_LOADED = 'EPILOT/JOURNEY_LOADED',
  USER_EVENT_PAGE_VIEW = 'EPILOT/USER_EVENT/PAGE_VIEW',
  USER_EVENT_PROGRESS = 'EPILOT/USER_EVENT/PROGRESS',
  CLOSE_JOURNEY = 'EPILOT/CLOSE_JOURNEY',
  ASSETS_READY = 'EPILOT/JOURNEY_ASSETS_LOADED',
  /**
   * Legacy event type, maintained for compatibility
   */
  LEGACY_EXIT_FULL_SCREEN = 'ExitFullScreen'
}

export type DispatchUserEventType =
  | EMBEDDED_JOURNEY_MESSAGE_EVENT_TYPE.USER_EVENT_PAGE_VIEW
  | EMBEDDED_JOURNEY_MESSAGE_EVENT_TYPE.USER_EVENT_PROGRESS
